import { useContext, useEffect, useMemo } from 'react';
import { useParams } from 'react-router';
import { isNil } from 'ramda';
import { rutiner } from '../../../Features/Delsystem/_Common/Const/Rutiner';
import { rutinInfos } from '../../../Features/Delsystem/_Common/Const/RutinInfo';
import {
  InternalError,
  internalErrorComp,
} from '../../../Components/InternalError/InternalError';
import { IRutinInfo } from '../../../Types/RutinInfoType';
import EDTypography from '../../../BaseComponents/Typography/EDTypography';
import { withActiveRoutine } from './Hocs';
import { ActiveDatabaseContext } from '../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { styrvarden } from '../../Delsystem/_Common/Const/Styrvarden';
import { IRapport, IRoutine } from '../../Delsystem/_Common/Const/Delsystem';
import { findRutinInfo } from '../../Delsystem/_Common/Utils/RutinInfoUtils';
import { LoginStateContext } from '../../Login/Contexts/LoginStateContext/LoginStateContext';
import NoSessionBackground from '../../Login/Components/NoSessionBackground/NoSessionBackground';
import { RollbarContext } from '@rollbar/react';
import { setPageTitle } from '../../../Utils/analyticsUtils';

const DeniedAccessRutin = (props: { rutin: IRutinInfo }) => {
  return (
    <EDTypography>{`Du har ej tillgång till rutinen ${props.rutin.benamning}`}</EDTypography>
  );
};

interface IProps {
  styrvarden?: boolean;
}

const RutinRouter = (props: IProps) => {
  const { rutinURL } = useParams<{ rutinURL: string }>();
  const loginState = useContext(LoginStateContext);
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const rutinKey: string | undefined = Object.keys(rutinInfos).find(
    rtnKey => rutinInfos[rtnKey].rutinURL === rutinURL
  );

  const rutinInfo = rutinKey == null ? undefined : findRutinInfo(rutinKey);

  useEffect(() => {
    setPageTitle(rutinInfo?.benamning || '-');
  }, [rutinInfo]);

  const rutinEllerStyrvärde: IRoutine | IRapport | undefined =
    rutinKey == null
      ? undefined
      : props.styrvarden
      ? styrvarden()[rutinKey]
      : rutiner[rutinKey];

  //Behörighet saknas (men först när det är säkert, så rutinen optimistiskt kan starta samtidigt som behörigheter initieras)
  const isUnAvailable =
    rutinInfo == null || activeDatabaseContext.activeDatabaseInfoLoading
      ? false
      : activeDatabaseContext.availableRoutines?.[rutinInfo.rutinID] == null;

  const RutinComp = useMemo(() => {
    if (rutinEllerStyrvärde == null || rutinInfo == null) {
      return internalErrorComp(
        '265dbf01-6169-4d22-92f5-31fcef61e59a',
        'Rutin eller rutinInfo saknas'
      );
    }
    return withActiveRoutine(rutinEllerStyrvärde, rutinInfo);
  }, [rutinEllerStyrvärde, rutinInfo]);

  if (isNil(rutinEllerStyrvärde) || isNil(rutinInfo)) {
    return (
      <InternalError
        id="d55aa12d-b488-4976-8496-b435788b1af8"
        errorName="RutinSaknas"
        message={`${
          props.styrvarden ? 'Styrvärdet' : 'Rutinen'
        } ${rutinURL} saknas. RutinKey är ${rutinKey}.`}
      />
    );
  }
  if (!loginState.isLoggedIn) {
    return <NoSessionBackground />;
  }
  if (isUnAvailable) {
    return <DeniedAccessRutin rutin={rutinInfo} />;
  }
  return (
    <RollbarContext context={rutinInfo.benamning}>
      <RutinComp />
    </RollbarContext>
  );
};
export default RutinRouter;
